import { PericiaUpdateWidget } from "../../features/pericia/update-pericia/ui/pericia-update-widget.component";

export const PericiaUpdatePage = () => <PericiaUpdateWidget />;
